import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails, Link } from '@mui/material';

import { JOB_POSTINGS } from '../../constants/Careers';

import './JobListings.css';

export const JobListings = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const handleMixpanelTrack = ({ name, role }) => {
    mixpanel.track('Job Post', {
      name,
      role,
    });
  };

  return (
    <div className="job-listing-container">
      <div>
        <h2 className="job-listing-header"> Join Us On Our Journey </h2>
        <h5 className="job-listing-sub-header"> Check and Apply For Some Available Openings </h5>

        <div className="job-listing-list">
          {JOB_POSTINGS.map((step) => (
            <Accordion
              sx={{
                '&:first-of-type': {
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                },
                '&:last-of-type': {
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px',
                },
                '&.Mui-expanded': {
                  margin: '0 auto',
                },
                border: '1px solid black',
                p: '1.25rem',
                p: { xs: '.5rem', sm: '0.5rem' },
                width: { xs: 'initial', sm: '98%' },
                margin: '0 auto',
                borderRadius: '10px',
              }}
              expanded={expandedSections[step.title]}
              onChange={() => {
                setExpandedSections((prevState) => {
                  const copyPrevState = { ...prevState };
                  if (prevState[step.title]) {
                    delete copyPrevState[step.title];

                    mixpanel.track('Job Post', {
                      stepTitle: step.title,
                      action: 'Close',
                    });

                    return copyPrevState;
                  }

                  mixpanel.track('Job Post', {
                    stepTitle: step.title,
                    action: 'Open',
                  });

                  return {
                    ...copyPrevState,
                    [step.title]: step.title,
                  };
                });
              }}
              key={step.title}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                className="job-listing-section-header"
                sx={{
                  '&.Mui-expanded': {
                    minHeight: '50px',
                  },
                }}
              >
                {step.title}
              </AccordionSummary>

              <AccordionDetails>
                <h3 style={{ textAlign: 'left', marginTop: 0, marginBottom: '10px' }}>
                  {step.team}
                </h3>
                <div className="job-listing-section-sub-header">
                  <strong>Role Description </strong> <br />{' '}
                  <div style={{ marginTop: '10px', fontSize: '16px' }}>{step.description?.()}</div>
                </div>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}
                >
                  <Link
                    href={step.learnMore}
                    target="_blank"
                    variant="body2"
                    underline="none"
                    color="purple"
                    sx={{ fontSize: '16px' }}
                    onClick={() => handleMixpanelTrack({ name: 'Learn More', role: step.title })}
                  >
                    Learn More
                  </Link>
                  <Link
                    variant="outline"
                    underline="none"
                    color="purple"
                    sx={{ fontSize: '16px' }}
                    href={`mailto:info@cashclever.net?subject=${step.title} Application`}
                    onClick={() =>
                      handleMixpanelTrack({ name: 'Apply With Resume', role: step.title })
                    }
                  >
                    Apply With Resume
                  </Link>
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  );
};
